import { render, staticRenderFns } from "./UsualPowerSettingsPage.vue?vue&type=template&id=496f7745&scoped=true&"
import script from "./UsualPowerSettingsPage.vue?vue&type=script&lang=ts&"
export * from "./UsualPowerSettingsPage.vue?vue&type=script&lang=ts&"
import style0 from "./UsualPowerSettingsPage.vue?vue&type=style&index=0&id=496f7745&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496f7745",
  null
  
)

export default component.exports